export default __webpack_public_path__ + "static/196-697f2a31dd10265be7da4b44c0f460e5.jpg";